import { fetchApi } from '@/config/axiosSetting';
import {
  SubstitutionPartsListParams,
  SubstitutionPartsListResponse,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getSubstitutionPartsList/getSubstitutionPartsListQuery.type';

export const substitutionPartsListQueryFunction = (
  params: SubstitutionPartsListParams,
): Promise<SubstitutionPartsListResponse> =>
  fetchApi.get(
    `property/reports/${params.id}/accident_users/damaged/adjusting/substitution_parts/list/`,
    {
      params,
    },
  );
